export default __webpack_public_path__ + "static/media/Topaz_partment_10.a1002e6b.jpg";